const Airdrop = ({ width = 20, height = 20, color = 'currentColor' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 26 26" fill="none">
      <path
        d="M15.3074 12.2851C15.7299 10.5085 14.1807 8.95924 12.404 9.38174C11.5699 9.58757 10.8874 10.2701 10.6815 11.1043C10.259 12.8809 11.8082 14.4301 13.5849 14.0076C14.4299 13.8018 15.1124 13.1193 15.3074 12.2851Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.5109 18.6228C21.3634 16.8895 22.5225 14.4303 22.5225 11.6895C22.5225 6.42447 18.2542 2.16699 13 2.16699C7.74586 2.16699 3.47754 6.4353 3.47754 11.6895C3.47754 14.4411 4.64754 16.922 6.5217 18.6553"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.66605 15.763C7.66939 14.7014 7.05188 13.2713 7.05188 11.6897C7.05188 8.40718 9.71689 5.74219 12.9994 5.74219C16.2819 5.74219 18.9469 8.40718 18.9469 11.6897C18.9469 13.2713 18.3294 14.6905 17.3327 15.763"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.1586 18.0487L9.59861 19.9879C8.36361 21.5371 9.45778 23.8229 11.4403 23.8229H14.5494C16.5319 23.8229 17.637 21.5263 16.3911 19.9879L14.8311 18.0487C13.8994 16.8679 12.1011 16.8679 11.1586 18.0487Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default Airdrop;
